<label class="clr-control-label">{{ label }}</label>
<div #editor></div>
